import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { orderBy } from 'src/app/services/mapping.service';
import { AddCurricularComponent } from '../add-curricular/add-curricular.component';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { Term } from 'src/app/stores/administrator/term.store';

@Component({
  selector: 'app-curricula',
  templateUrl: './curricula.component.html',
  styleUrls: ['./curricula.component.scss']
})
export class CurriculaComponent implements OnInit {
  SELECTED_FACULTY: any = null;
  tabs: any[] = [];

  constructor(
    private auth: AuthService,
    private list: List,
    private route: ActivatedRoute,
    public store: Term,
    private ds: DataService,
    public dialog: MatDialog) { }

  async ngOnInit() {
    await this.auth.fetchEnvironment()
    this.route.parent.params.subscribe(async params => {
      const { id } = params;
      this.SELECTED_FACULTY = id;
      const { UNIVERSITY_LEVEL } = this.auth.config;
      this.tabs = orderBy(await this.list.fetchList(this.ds.degreeRef(ref => ref.where('levelKey', "==", UNIVERSITY_LEVEL))), "order")
    })
  }


  create() {
    const dialogRef = this.dialog.open(AddCurricularComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
